import { KML } from 'ol/format';
import JSZip from "jszip";

export default class KMZ extends KML {
    constructor(opt_options) {
      let options = opt_options || {};
      let zip = new JSZip();
      function getKMLImage(href) {
        let url = href;
        let path = window.location.href.split("?")[0];		//returns the href (URL) of the current page
        path = path.slice(0, path.lastIndexOf('/') + 1); // path ist die URL vom Anfang bis einschließlich letzten /
        if (href.indexOf(path) === 0) {	//gibt den Index des ersten Buchstaben von path in der Url zurück. Falls -1 käme path nicht darin vor
          let regexp = new RegExp(href.replace(path, '') + '$', 'i'); //regular expression: der path Teil der URl wird gelöscht. $ heißt Ende des Strings. i heißt Groß- Kleinschreibung ignorieren
          let kmlFile = zip.file(regexp)[0];	//zip.file(): Get a file with the specified name. Sucht nach drag-and-drop-custom-kmz.html im Bsp
          if (kmlFile) {
            url = URL.createObjectURL(new Blob([kmlFile.asArrayBuffer()])); //Bild in url codiert
          }
        }
        return url;
      }
      options.iconUrlFunction = getKMLImage;
      super(options);
      this.zip = zip;
    }



    getKMLData(buffer) {

      let kmlData;
      this.zip.load(buffer); //buffer wird in dem JSZip Objekt gespeichert. buffer = kmlData später
      let kmlFile = this.zip.file(/.kml$/i)[0]; //kmlFile ist ein .kml file aus dem JSZip-Objekt. Returns : An array of matching files
      if (kmlFile) {
        kmlData = kmlFile.asText();
      }
      return kmlData;
    }



    getType () {
      return 'arraybuffer';
    }

    readFeature (source, options) {
      let kmlData = this.getKMLData(source);
      return super.readFeature(kmlData,options)
    }

    readFeatures (source, options) {
      let kmlData = this.getKMLData(source);
      return super.readFeatures(kmlData, options);
    }

}